'use client';

import {
  FC,
  PropsWithChildren,
  useContext,
  useLayoutEffect,
  useRef
} from 'react';
import { mapCtx } from './MapContext';
import { MapControlProps } from './types';
import cx from 'classnames';
export const MapControl: FC<PropsWithChildren<MapControlProps>> = ({
  position = 'TOP_LEFT',
  children,
  isMobileFullMapViewEnabled = false,
  isMobile = false
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const map = useContext(mapCtx);

  useLayoutEffect(() => {
    if (!map || !ref.current) return;

    const controlPosition = google.maps.ControlPosition[position];
    map.controls[controlPosition].push(ref.current);
  }, [map, position]);

  return (
    <div
      ref={ref}
      data-testid="map-control"
      className={cx({
        'h-100': isMobileFullMapViewEnabled && isMobile
      })}
    >
      {children}
    </div>
  );
};
